(
    function (skyward, $, undefined)
    {
        skyward.timetracking = skyward.timetracking || {};

        // ALSO UPDATE TimeTracking/ConfigDistrict.cs when changing the default message
        skyward.timetracking.resetwaitingmessage = function ()
        {
            var waitingMessageSubject = $('#editConfigDistrict_TimesheetSubmissionWaitingMessageSubject');
            var waitingMessageContent = $('#editConfigDistrict_TimesheetSubmissionWaitingMessageContent');
            var defaultWaitingMessageSubject = 'Timesheet Submission Approval for {TaskInstance.ApprovalTaskPresenter.TimesheetSubmission.TimesheetWeek.Employee.Name.FullNameFML}';
            var defaultWaitingMessageContent = '{User.Name.FirstName},\n\n{TaskInstance.ApprovalTaskPresenter.TimesheetSubmission.TimesheetWeek.Employee.Name.FullNameFML} has a timesheet submission waiting for your approval at {TaskInstance.ApprovalTaskPresenter.Description}';

            skyward.controls.setValue(waitingMessageSubject, defaultWaitingMessageSubject, false);
            skyward.controls.setValue(waitingMessageContent, defaultWaitingMessageContent, false);
        };

        // ALSO UPDATE TimeTracking/ConfigDistrict.cs when changing the default message
        skyward.timetracking.resetapprovedmessage = function ()
        {
            var approvedMessageSubject = $('#editConfigDistrict_TimesheetSubmissionApprovedMessageSubject');
            var approvedMessageContent = $('#editConfigDistrict_TimesheetSubmissionApprovedMessageContent');
            var defaultApprovedMessageSubject = 'Your Timesheet Submission Has Been Approved';
            var defaultApprovedMessageContent = '{TimesheetSubmission.TimesheetWeek.Employee.Name.FirstName},\n\nYour timesheet submission for {TimesheetSubmission.StartDate} - {TimesheetSubmission.EndDate} has been approved by {Approver.FullNameFL}';

            skyward.controls.setValue(approvedMessageSubject, defaultApprovedMessageSubject, false);
            skyward.controls.setValue(approvedMessageContent, defaultApprovedMessageContent, false);
        };

        // ALSO UPDATE TimeTracking/ConfigDistrict.cs when changing the default message
        skyward.timetracking.resetdeniedmessage = function ()
        {
            var deniedMessageSubject = $('#editConfigDistrict_TimesheetSubmissionDeniedMessageSubject');
            var deniedMessageContent = $('#editConfigDistrict_TimesheetSubmissionDeniedMessageContent');
            var defaultDeniedMessageSubject = 'Your Timesheet Submission Has Been Denied';
            var defaultDeniedMessageContent = '{TimesheetSubmission.TimesheetWeek.Employee.Name.FirstName}, \n\nYour timesheet submission for {TimesheetSubmission.StartDate} - {TimesheetSubmission.EndDate} has been denied by {Approver.FullNameFL}, Comment: {Comment}';

            skyward.controls.setValue(deniedMessageSubject, defaultDeniedMessageSubject, false);
            skyward.controls.setValue(deniedMessageContent, defaultDeniedMessageContent, false);
        };

        function showEmployeeScheduleLegendAdmin()
        {
            let info = $.ajax(skyward.global.virtualDir + "TimeTracking/EmployeeSchedule/LegendAdmin",
                {
                    data:
                    {
                        renderType: "contentOnly"
                    }
                });
            skyward.modalLayer.showInformationBubble("Legend", info, [], { anchorTo: this });
        }

        function showEmployeeScheduleLegendEA()
        {
            let info = $.ajax(skyward.global.virtualDir + "TimeTracking/EmployeeSchedule/LegendEmployeeAccess",
                {
                    data:
                    {
                        renderType: "contentOnly"
                    }
                });
            skyward.modalLayer.showInformationBubble("Legend", info, [], { anchorTo: this });
        }

        function showEmployeeScheduleLegendDetailsSupervisedEmployee() {
            let info = $.ajax(skyward.global.virtualDir + "TimeTracking/EmployeeSchedule/LegendDetailsSupervisedEmployee",
                {
                    data:
                    {
                        renderType: "contentOnly"
                    }
                });
            skyward.modalLayer.showInformationBubble("Legend", info, [], { anchorTo: this });
        }

        function showEmployeeScheduleLegendSupervisedEmployeeSchedule()
        {
            let info = $.ajax(skyward.global.virtualDir + "TimeTracking/EmployeeSchedule/LegendSupervisedEmployeeSchedule",
                {
                    data:
                    {
                        renderType: "contentOnly"
                    }
                });
            skyward.modalLayer.showInformationBubble("Legend", info, [], { anchorTo: this });
        }

        function showEmployeeScheduleLegendLimitedEmployee()
        {
            let info = $.ajax(skyward.global.virtualDir + "TimeTracking/EmployeeSchedule/LegendLimitedEmployee",
                {
                    data:
                    {
                        renderType: "contentOnly"
                    }
                });
            skyward.modalLayer.showInformationBubble("Legend", info, [], { anchorTo: this });
        }

        const deviationDayPopup = function ()
        {
            const button = $(this);
            const data = button.data();
            const popupData =
            {
                renderType: 'contentOnly',
                description: data.description,
            };

            const buildPopup = function ()
            {
                return $.ajax({
                    url: `${skyward.global.virtualDir}TimeTracking/EmployeeSchedule/GetDeviationDayPopup${data.accessMode}`,
                    type: 'POST',
                    dataType: 'HTML',
                    data: popupData
                });
            }

            const closeButton = { id: "closeButton", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
            const dialog = skyward.modalLayer.showDialog("Deviation Day Description", buildPopup, [closeButton], { anchorTo: this });
        }

        var initBaseScheduleRotationsBrowse = function ()
        {
            var browse = $(this);
            browse.on("rowChanged", function ()
            {
                updateBaseScheduleRotationWeeklySchedule();
            });

            function updateBaseScheduleRotationWeeklySchedule()
            {
                $.ajax(
                    {
                        url: skyward.global.virtualDir + "TimeTracking/BaseScheduleRotation/UpdateBaseScheduleRotationWeeklySchedule",
                        type: "POST",
                        dataType: "json",
                        data:
                        {
                            baseScheduleID: skyward.browse.browseList[browse.attr("id")].data.BaseScheduleID,
                            districtID: skyward.browse.browseList[browse.attr("id")].data.DistrictID,
                            baseScheduleRotationID: browse.find(".browseRow.current").data("targetid"),
                        },
                        success: function (data)
                        {
                            $("#BaseScheduleRotationWeeklySchedule").replaceWith(data.html)
                            $("#BaseScheduleRotationWeeklySchedule").find('div .toCollapse').removeClass('expanded toCollapse').addClass('collapsed');
                        }
                    });
            }

            browse.on("browseLoaded." + browse.attr("id"), function () { updateBaseScheduleRotationWeeklySchedule() });
        }

        function showBaseScheduleLegend() {
            let info = $.ajax(skyward.global.virtualDir + "TimeTracking/BaseSchedule/Legend",
                {
                    data:
                    {
                        renderType: "contentOnly"
                    }
                });
            skyward.modalLayer.showInformationBubble("Legend", info, [], { anchorTo: this });
        }

        var calendarSeekToDate = function ()
        {
            var calendarDiv = $(".fullPageCalendar");
            var fullCalendar = calendarDiv.data("calendar");

            var seekDateField = $('.calendarSeekTextBox');
            var seekDate = skyward.time.parseDate(seekDateField.val().split(' ')[0]);

            if (seekDate.isValidDate())
            {
                fullCalendar.gotoDate(seekDate);
            }
        };

        var calendarSeekEventHandler = function (element)
        {
            var seekDateField = $('.calendarSeekTextBox');

            //force the datepicker to format the date on enter key, for a 2 digit year for example
            seekDateField.blur();
            seekDateField.focus();

            calendarSeekToDate();
        };

        var calendarSeekTextBox = $('.calendarSeekTextBox');
        calendarSeekTextBox.on("keydown", function (e)
        {
            var eventKeys = skyward.keys.getKeyNamesFromEvent(e);

            if (eventKeys.ENTER)
            {
                var element = $(this);
                if (element.is(".datepicker"))
                {
                    element.datepicker("hide");
                }
                calendarSeekEventHandler.apply(element, arguments);
                e.stopPropagation();
                e.preventDefault();
            }
        });

        // Event handlers
        let events =
        {
            'showEmployeeScheduleLegendAdmin': showEmployeeScheduleLegendAdmin,
            'showEmployeeScheduleLegendEA': showEmployeeScheduleLegendEA,
            'showEmployeeScheduleLegendDetailsSupervisedEmployee': showEmployeeScheduleLegendDetailsSupervisedEmployee,
            'showEmployeeScheduleLegendSupervisedEmployeeSchedule': showEmployeeScheduleLegendSupervisedEmployeeSchedule,
            'showEmployeeScheduleLegendLimitedEmployee': showEmployeeScheduleLegendLimitedEmployee,
            'showBaseScheduleLegend': showBaseScheduleLegend,
            'initBaseScheduleRotationsBrowse': initBaseScheduleRotationsBrowse,
            'calendarSeekToDate': calendarSeekToDate,
            'deviationDayPopup': deviationDayPopup
        };
        skyward.events.registerEvents("timetracking", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);